import { render, staticRenderFns } from "./CommandesItemArticles.vue?vue&type=template&id=03c1ad96&"
import script from "./CommandesItemArticles.vue?vue&type=script&lang=js&"
export * from "./CommandesItemArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports